<template>
  <div class="record-box">
    <div v-show="!showEffectAnalysis && !showEffectAnalysisX" class="box-shadow top-box">
      <!-- <div class="global-title">
       {{ this.$route.meta.desc }} {{typeIndex}}
      </div> -->
      <top-title name="订单发送"></top-title>

      <div class="tab-line">
        <div
          class="tab-item"
          @click="handleSwitch(1)"
          :class="{ active: tabIndex == '1' }"
          :style="{
            color: tabIndex == '1' ? globalBG : '',
            'border-top': tabIndex == '1' ? '2px solid ' + globalBG : '',
          }"
        >
          订单发送
          <span></span>
        </div>
        <div
          class="tab-item"
          @click="handleSwitch(2)"
          :class="{ active: tabIndex == '2' }"
          :style="{
            color: tabIndex == '2' ? globalBG : '',
            'border-top': tabIndex == '2' ? '2px solid ' + globalBG : '',
          }"
        >
          短信记录
          <span></span>
        </div>
        <div
          class="tab-item"
          @click="handleSwitch(3)"
          :class="{ active: tabIndex == '3' }"
          :style="{
            color: tabIndex == '3' ? globalBG : '',
            'border-top': tabIndex == '3' ? '2px solid ' + globalBG : '',
          }"
        >
          营销效果
          <span></span>
        </div>
      </div>
      <!-- 订单发送 -->
      <order-send @onViewRecord="handleViewRecord" v-if="tabIndex == 1 && typeIndex == 5"></order-send>

      <!-- 查询表单（短信营销+效果分析） -->
      <div class="search-box" v-if="tabIndex != 1">
        <el-form ref="formSearch" :inline="true" :model="form" label-width="120px">
          <el-form-item label="活动主题:" v-if="titleShow">
            <el-input size="small" v-model="form.activityTitle" placeholder="请输入活动主题"></el-input>
          </el-form-item>
          <el-form-item label="短信内容:" v-if="contentShow">
            <el-input size="small" v-model="form.content" placeholder="请输入短信内容"></el-input>
          </el-form-item>
          <el-form-item label="短信类型:">
            <el-select size="small" v-model="form.smsType">
              <el-option v-for="(item, index) in smsTypeList" :key="index" :value="item.value"
                :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="手机号码:" v-if="(tabIndex == 2 && typeIndex == 3) || (typeIndex == 4 && tabIndex == 2)">
            <el-input size="small" v-model="form.phone" placeholder="请输入手机号码"></el-input>
          </el-form-item>
          <el-form-item label="活动类型:" v-if="activeTypeShow">
            <el-select size="small" v-model="form.officialFlag">
              <el-option v-for="(item, index) in officialFlagList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送类型:" v-if="sendTypeShow">
            <el-select size="small" v-model="form.sendType">
              <el-option v-for="(item, index) in sendTypeList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发送状态:" v-if="sendStatusShow">
            <el-select size="small" v-model="form.sendStatus">
              <el-option v-for="(item, index) in sendStatusList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="提交时间:" v-if="submitTimeShow">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.submitTimeStart"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.submitTimeEnd"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime1()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </el-form-item>
          <el-form-item label="效果分析:" v-if="versionShow">
            <el-select size="small" v-model="form.version" key="version" @change="switchAnalysis">
              <el-option v-for="(item, index) in versionList" :key="index" :value="item.value" :label="item.label"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="发送时间:" v-if="sendTimeShow">
            <div class="my_select_time">
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendTimeStart"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="form.sendTimeEnd"
                type="datetime"
                :placeholder="'选择日期时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
              ></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTimeSendTime()"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </el-form-item>
        </el-form>
        <div class="el_btn">
          <el-button
            size="small"
            :disabled="tableLoding"
            class="search"
            v-zoom="{ from: pageName, name: '查询' }"
            @click="
              form.current = 1;
              submitForm('formSearch');
            "
          >
            <i class="el-icon-search" style="display: inline-block; width: 14px; height: 12px"></i>
            查询
          </el-button>
          <el-button size="small" class="reset" @click="resetForm">重置</el-button>
        </div>
      </div>
      <div class="table-box" v-if="tabIndex != 1">
        <!-- 效果分析 -->
        <div v-if="tabIndex == 2 && typeIndex == 1" style="color: #fe4d45; padding-bottom: 5px; margin-left: 30px">
          注意：短信扣费先按照提交条数预扣相应短信条数，余额会减少，发送后4~7天会按照京东实际返回的短信状态报告成功扣费，短信条数多退少补。
        </div>
        <div class="batchUpload" v-if="tabIndex == 3 && (typeIndex == 1 || typeIndex == 2 || typeIndex == 5)">
          <el-button class="status_btn3" :disabled="form.version == 1" @click="staVisible = true">批量下载</el-button>
        </div>
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="tableLoding"
          tooltip-effect="light"
          id="table_id"
          style="width: 100%; border: 1px solid #eee"
        >
          <template slot="empty">
            <div>
              <img src="@/assets/images/default/暂无任何数据.png" />
              <span style="margin-left: -140px">暂无任何数据</span>
            </div>
          </template>
          <el-table-column label="序号" type="index" width="80px"></el-table-column>
          <el-table-column label="活动主题" prop="activityTitle" :width="typeIndex == '1' && tabIndex == '3' ? '300' : '250'"></el-table-column>
          <el-table-column key="activiveType" label="活动类型" v-if="typeIndex == '1' && tabIndex == '2'">
            <template>精准营销</template>
          </el-table-column>
          <el-table-column label="短信类型" key="sendType" width="120px">
            <template slot-scope="scope">
              <span v-if="scope.row.smsType == 0">普通短信</span>
              <span v-else-if="scope.row.smsType == 1">富信</span>
              <span v-else-if="scope.row.smsType == 2">卡片短信</span>
            </template>
          </el-table-column>
          <el-table-column
            key="content"
            label="短信内容"
            min-width="120px"
            prop="content"
            :width="typeIndex == '1' && tabIndex == '3' ? '400' : '150'"
          >
            <template slot="header" slot-scope="scope">
              <span>短信内容</span>
              <span
                v-if="!allShow"
                :style="{ color: globalBG }"
                @click="
                  allShow = true;
                  doLayout();
                "
                class="table-message"
                >(展开全部)</span
              >
              <span
                v-if="allShow"
                :style="{ color: globalBG }"
                @click="
                  allShow = false;
                  doLayout();
                "
                class="table-message"
                >(单行显示)</span
              >
            </template>
            <template slot-scope="scope">
              <div>
                <el-tooltip class="item" effect="light" :content="scope.row.smsType == 1 ? scope.row.mediaTitle : scope.row.content" placement="top">
                  <div class="hoveTitle" v-show="!allShow">
                    <span v-if="scope.row.smsType == 1" class="rich_title" @click="showMediaInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                    <span v-else-if="scope.row.smsType == 2" class="rich_title" @click="showCardInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                    <span v-else>{{ scope.row.content }}</span>
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShow">
                  <span v-if="scope.row.smsType == 1" class="rich_title" @click="showMediaInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                  <span v-else-if="scope.row.smsType == 2" class="rich_title" @click="showCardInfo(scope.row)">{{ scope.row.mediaTitle }}</span>
                    <span v-else>{{ scope.row.content }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="发送类型" key="sendType" v-if="typeIndex != '1' && tabIndex == '2'">
            <template slot-scope="scope">
              {{ scope.row.sendType == "0" ? "立即发送" : "" }}
              {{ scope.row.sendType == "1" ? "定时发送" : "" }}
            </template>
          </el-table-column>
          <el-table-column
            key="selectedCrowd"
            :width="typeIndex == '1' && tabIndex == '3' ? '400' : '220'"
            label="活动对象"
            v-if="typeIndex == '1' && (tabIndex == '3' || tabIndex == '2')"
          >
            <template slot="header" slot-scope="scope">
              <span>活动对象</span>
              <span
                v-if="!allShowCrowd"
                :style="{ color: globalBG }"
                @click="
                  allShowCrowd = true;
                  doLayout();
                "
                class="table-message"
                >(展开全部)</span
              >
              <span
                v-if="allShowCrowd"
                :style="{ color: globalBG }"
                @click="
                  allShowCrowd = false;
                  doLayout();
                "
                class="table-message"
                >(单行显示)</span
              >
            </template>
            <template slot-scope="scope" v-if="scope.row.selectedCrowd">
              <div>
                <el-tooltip class="item" effect="light" :content="scope.row.selectedCrowd | showSelectedCrowd" placement="top">
                  <div class="hoveTitle" v-show="!allShowCrowd">
                    {{ scope.row.selectedCrowd | showSelectedCrowd }}
                  </div>
                </el-tooltip>
                <div class="hoveTitleShowMore" v-show="allShowCrowd">
                  {{ scope.row.selectedCrowd | showSelectedCrowd }}
                </div>
              </div>
              <!-- <div class="select-box">
                <span style="font-size:14px">选择人群</span>
                <span
                  v-for="(item, index) in scope.row.selectedCrowd.includeCrowd"
                  :key="index"
                >{{item.strategyName}}</span>
                <span>关系</span>
                <span>{{scope.row.selectedCrowd.includeRule == '1' ? '合集' : '并集'}}</span>
              </div>
              <div class="select-box" v-if="scope.row.selectedCrowd.excludeFlag">
                <span style="font-size:14px">选择人群</span>
                <span
                  v-for="(item, index) in scope.row.selectedCrowd.excludeCrowd"
                  :key="index"
                >{{item.strategyName}}</span>
                <span>关系</span>
                <span>{{scope.row.selectedCrowd.excludeRule == '1' ? '合集' : '并集'}}</span>
              </div> -->
            </template>
          </el-table-column>

          <el-table-column
            label="提交时间"
            key="submitTime"
            width="160px"
            v-if="(typeIndex == '1' && tabIndex == '2') || (typeIndex != '1' && tabIndex == '2')"
            prop="submitTime"
          ></el-table-column>
          <el-table-column label="发送时间" key="sendTime" prop="sendTime" width="160px"></el-table-column>
          <el-table-column v-if="typeIndex != '1'" label="发送人数" key="sendSubmitNum" prop="sendSubmitNum"></el-table-column>
          <el-table-column v-if="typeIndex == '1' && tabIndex == '3'" label="实际触达人数" key="sendNum" prop="sendNum" width="110"></el-table-column>
          <!-- 精准营销的发送状态 -->
          <el-table-column label="发送状态" key="sendStatus" v-if="typeIndex == '1' && tabIndex == '2'">
            <template slot-scope="scope">
              <span>
                {{ scope.row.sendStatus == "1" ? "待审核" : "" }}
                {{ scope.row.sendStatus == "3" ? "待发送" : "" }}
                {{ scope.row.sendStatus == "4" ? "审核未通过" : "" }}
                {{ scope.row.sendStatus == "5" ? "已取消" : "" }}
                {{ scope.row.sendStatus == "100" ? "发送中" : "" }}
                {{ scope.row.sendStatus == "101" ? "已发送" : "" }}
                {{ scope.row.sendStatus == "102" ? "发送失败" : "" }}
              </span>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.failMessage"
                placement="top-start"
                v-if="scope.row.sendStatus == '4' || scope.row.sendStatus == '102'"
              >
                <span class="question_icon" style="color: #fe4d45 !important; border-color: #fe4d45">?</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <!-- 非精准营销的发送您状态 -->
          <el-table-column label="发送状态" key="sendStatus" v-if="typeIndex != '1' && tabIndex == '2'">
            <template slot-scope="scope">
              <span>
                {{ scope.row.sendStatus == "1" ? "待审核" : "" }}
                {{ scope.row.sendStatus == "2" ? "待发送" : "" }}
                {{ scope.row.sendStatus == "3" ? "已发送" : "" }}
                {{ scope.row.sendStatus == "4" ? "已取消" : "" }}
                {{ scope.row.sendStatus == "5" ? "发送失败" : "" }}
                {{ scope.row.sendStatus == "6" ? "提交中" : "" }}
                {{ scope.row.sendStatus == "7" ? "提交失败" : "" }}
                {{ scope.row.sendStatus == "8" ? "审核未通过" : "" }}
                {{ scope.row.sendStatus == "9" ? "发送中" : "" }}
              </span>
              <el-tooltip
                class="item"
                effect="light"
                :content="scope.row.failMessage"
                placement="top-start"
                v-if="scope.row.sendStatus == '5' || scope.row.sendStatus == '7' || scope.row.sendStatus == '8'"
              >
                <span class="question_icon" style="color: #fe4d45 !important; border-color: #fe4d45">?</span>
              </el-tooltip>
            </template>
          </el-table-column>

          <el-table-column v-if="typeIndex == '1' && tabIndex == '2'" key="sendSubmitNum" label="提交人数" prop="sendSubmitNum"></el-table-column>
          <el-table-column v-if="typeIndex == '1' && tabIndex == '2'" key="feeCount1" label="预扣费条数" prop="feeCount"></el-table-column>
          <el-table-column
            label="短信量"
            v-if="(typeIndex == '1' && tabIndex == '2') || (typeIndex != '1' && tabIndex == '2')"
            prop="feeCount"
            key="feeCount2"
          ></el-table-column>
          <el-table-column
            label="成交金额"
            v-if="typeIndex != '1' && tabIndex == '3'"
            key="totalOrderAmount"
            prop="totalOrderAmount"
          ></el-table-column>
          <el-table-column v-if="typeIndex == '1' && tabIndex == '2'" label="实际发送人数" key="sendNum2" prop="sendNum" width="125">
            <template slot="header" slot-scope="scope">
              <span>实际发送人数</span>
              <el-tooltip class="item" effect="light" content="短信发送完成后京东会返回实际发送人数" placement="top-start">
                <span class="question_icon">?</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column v-if="typeIndex == '1' && tabIndex == '2'" key="realFeeCount" prop="realFeeCount" width="125">
            <template slot="header" slot-scope="scope">
              <span>实际扣费条数</span>
              <el-tooltip
                class="item"
                effect="light"
                content="实际扣费条数京东官方会在发送后2天返回，发送后未返回显示--，发送失败显示0，已发送会显示具体扣费条数；"
                placement="top-start"
              >
                <span class="question_icon">?</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column v-if="typeIndex == '1' && tabIndex == '2'" label="退回条数" key="refundCount" prop="refundCount" width="100">
            <template slot="header" slot-scope="scope">
              <span>退回条数</span>
              <el-tooltip
                class="item"
                effect="light"
                content="根据京东官方通道实际返回的状态报告结算，状态报告失败的会退回相应条数；"
                placement="top-start"
              >
                <span class="question_icon">?</span>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" :min-width="tabIndex == 2 ? '160px' : '160px'">
            <template slot-scope="scope">
              <div class="control-button" v-if="tabIndex == 2">
                <span v-if="isPremissionShow">
                  <el-button type="text"
                    class="operation"
                    style="margin-right: 8px"
                    v-if="(typeIndex == '1'&&scope.row.sendStatus == '101') ||(typeIndex != '1'&&scope.row.sendStatus == '3')"
                    @click="secondMarketingFn(scope.row)"
                    >二次营销
                  </el-button>
                  <el-button style="margin-right: 8px" type="text" :disabled="true"  v-else>二次营销</el-button>
                </span>
                <el-button
                  class="operation"
                  type="text"
                  v-if="typeIndex == 1 || scope.row.dataFrom == 5 || scope.row.dataFrom == 6"
                  @click="reMarketing(scope.row, scope.$index)"
                  >复制新建</el-button
                >
                <!-- 精准营销的取消发送 -->
                <el-button
                  class="operation"
                  type="text"
                  v-zoom="{ from: '精准营销' + pageName, name: '取消发送' }"
                  v-if="typeIndex == 1 && (scope.row.sendStatus == 1 || scope.row.sendStatus == 3)"
                  @click="handleCancelPrecision(scope.row, scope.$index)"
                >
                  取消发送</el-button
                >
                <el-button
                  class="operation"
                  v-if="typeIndex == 1 && !(scope.row.sendStatus == 1 || scope.row.sendStatus == 3)"
                  type="text"
                  style="color: #dddddd"
                  >取消发送</el-button
                >
                <!-- 非精准营销的取消发送 -->
                <el-button
                  class="operation"
                  v-zoom="{ from: '非精准营销' + pageName, name: '取消发送' }"
                  v-if="typeIndex != 1 && (scope.row.sendStatus == 1 || scope.row.sendStatus == 2)"
                  @click="handleCancelSend(scope.row, scope.$index)"
                  type="text"
                  >取消发送</el-button
                >
                <el-button
                  class="operation"
                  v-if="typeIndex != 1 && !(scope.row.sendStatus == 1 || scope.row.sendStatus == 2)"
                  type="text"
                  style="color: #dddddd"
                  >取消发送</el-button
                >
                <!-- <el-button
                  class="operation"
                  v-if="typeIndex != 1 && !(scope.row.sendStatus == 1 || scope.row.sendStatus == 2)"
                  type="text"
                  style="color:#dddddd"
                  >取消发送</el-button
                > -->
                <!-- 非精准营销 待审核 待发送 -->
                <div v-if="typeIndex != 1" style="display: inline-block">
                  <el-button
                    type="text"
                    class="record-btn"
                    v-zoom="{ from: pageName, name: '短信记录' }"
                    @click="handleSmsRecord(scope.row, scope.$index)"
                    :disabled="scope.row.sendStatus == '5' || scope.row.sendStatus == '7'"
                    >短信记录</el-button
                  >
                  <!-- 非精准营销 非发送失败 非提交失败 -->
                </div>
                <!-- 会员发送 再次营销 -->
                <el-button
                  class="operation"
                  type="text"
                  v-if="typeIndex == 2 && scope.row.isAllowSendAgain"
                  @click="reMarketMember(scope.row, scope.$index)"
                  >复制新建</el-button
                >
                <el-button class="operation" type="text" v-if="typeIndex == 2 && !scope.row.isAllowSendAgain" style="color:#dddddd"
                  >复制新建</el-button
                >
              </div>
              <div v-if="tabIndex == 3">
                <el-button
                  type="text"
                  style="width: 70px"
                  class="operation"
                  v-zoom="{ from: pageName, name: '效果分析' }"
                  @click="handeleEffect(scope.row)"
                  >效果分析</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页器 -->
        <div>
          <el-pagination
            background
            style="text-align: right; margin-top: 20px"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="form.current"
            :page-sizes="[10, 20, 30, 50, 100, 500]"
            :page-size="form.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="crowdTotal"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 短信记录弹窗 -->
    <sms-record v-if="smsVisible" @onClose="handleCloseSms" :visible="smsVisible" :batchId="batchId" :officialFlag="officialFlag"></sms-record>
    <!-- 效果分析页面 -->
    <effect-analysis
      v-if="showEffectAnalysis"
      :homeJump="homeJump"
      :sendDay="sendDay"
      :effectObj="selectEffectObj"
      :typeEffect="typeEffect"
      @onClose="goBackHome"
    ></effect-analysis>

    <!-- 效果分析新版页面 -->
    <effect-analysis-x v-if="showEffectAnalysisX" :officialObj="officialObj" @onClose="goBackHomeX" :homeJump="homeJump"> </effect-analysis-x>

     <!-- 二次营销弹窗 -->
     <second-marketing :secondMarketingVisible="secondVisible" :smsType="smsType" :recordId="recordId" :activityTitle="activityTitle" :secondSource="secondSource" v-if="secondVisible" @close="secondVisible = false"></second-marketing>
    
    <!-- 去设置弹层 -->
    <SetDialog :visible="setDialogVisible" @close="setDialogVisible = false"></SetDialog>

    <el-dialog title="统计时间" width="650px" :visible.sync="staVisible">
      <template slot="title">
        <span style="font-size: 16px; color: #333333; font-weight: bold; margin-right: 6px;">统计时间</span>  
        <el-popover
          placement="right"
          width="400"
          trigger="hover"
        >
          营销效果从发送后第二天开始统计，最多统计发送后30天的数据，每天0点更新数据，所有数据由京东提供
          <i class="el-icon-question" slot="reference" style="color: #aaaaaa;"></i>
        </el-popover>
      </template>
      <el-form>
        <el-form-item label="效果数据时间">
          <el-select style="width: 100px;" v-model="staValue" @change="staValueChange">
            <el-option
              v-for="(item, index) in statiType"
              :key="index"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <template v-if="staValue == ''">
            <el-select style="margin: 0 10px; width: 110px;" v-model="timeType">
              <el-option label="相对时间" :value="1"></el-option>
              <el-option label="绝对时间" :value="2"></el-option>
            </el-select>
            <el-input
              style="width: 160px;"
              v-model="customValue"
              @keyup.native="customValue = limitInput($event)"
              v-if="timeType == 1"
            >
              <template slot="suffix"> 天 </template>
            </el-input>
            <div class="my_select_time" v-else>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="startTime"
                type="datetime"
                :placeholder="'开始时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 120px; font-size: 12px"
                class="time1"
                :clearable="false"
                :picker-options="startTimeOption"
              ></el-date-picker>
              <div class="time_to_text" style="margin-top: 1px !important">
                至
              </div>
              <el-date-picker
                prefix-icon="no_icon"
                v-model="endTime"
                type="datetime"
                :placeholder="'结束时间'"
                size="small"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px; font-size: 12px"
                class="time2"
                :clearable="false"
                :picker-options="endTimeOption"
                default-time="23:59:59"
              ></el-date-picker>
              <i
                class="el-icon-circle-close date_icon1"
                @click="clearEffectTime()"
              ></i>
              <img
                src="@/assets/images/select_date.svg"
                alt
                class="date_icon2"
              />
            </div>
          </template>
        </el-form-item>
        <el-form-item label="添加备注" style="margin-left:18px">
          <el-input
            show-word-limit
            maxlength="20"
            type="textarea"
            :rows="3"
            style="width:220px; margin-left: 10px"
            v-model="customValue1"
          >
          </el-input>
        </el-form-item>

      </el-form>
      <div class="footer">
        <button class="cancel" @click="staVisible = false">取消</button>
        <button class="confirm" @click="batchUpload">确定</button>
      </div>
    </el-dialog>
    <!-- 富信模板 -->
    <sms-info 
      v-if="smsInfoShow" 
      @close="smsInfoShow = false" 
      :isShow="smsInfoShow" 
      :id="smsInfoId"
      :title="smsInfoTitle"
      :text="smsInfoText"
    />
    <sms-info-card 
      v-if="smsInfoCardShow"
      :isShow="smsInfoCardShow"
      :id="smsInfoCardId"
      @close="smsInfoCardShow = false" 
    ></sms-info-card>
    <!-- 生成报表 -->
    <generate :control = 'control'
               v-if="control" 
               @transData="(val) => (control = val)"
               :flags= 'flags'
               ></generate>
  </div>
</template>

<script>
import { getEffectPage,exportMarketing } from "@/api/smsMarketing";
import { getRecordListOfficial, getRecordMarketing, cancelSendSms } from "@/api/marketing/precisionMarketing";
import topTitle from "@/components/top-title.vue";
import { sendBatchPage, sendCancel, againSend } from "@/api/smsSend";
import { getSmsRecord } from "@/api/smsRecordController";
import generate from '../../components/generate_report.vue'
import effectAnalysis from "@/components/effect-analysis.vue";
import effectAnalysisX from "@/components/effect-analysis-x.vue";
import smsRecord from "@/components/sms-record.vue";
import orderSend from "./marketing/order_sent.vue";
import SetDialog from "@/components/SetDialog";
import smsInfo from '@/components/sms-info'
import smsInfoCard from '@/components/sms-info-card'
import { mapState } from "vuex";
import secondMarketing from "@/components/secondMarketing.vue";
export default {
  /** 营销记录及效果分析 */
  name: "marketinRecord",
  components: {
    smsRecord,
    effectAnalysis,
    effectAnalysisX,
    orderSend,
    SetDialog,
    topTitle,
    smsInfo,
    smsInfoCard,
    generate,
    secondMarketing
  },
  data() {
    return {
      smsType: 0,
      isPremissionShow: false,
      activityTitle: "",
      secondSource: 3,
      recordId: "",
      secondVisible: false,
      smsInfoCardShow: false, // 
      smsInfoCardId: "", // 
      timeType: 1,
      flags:0,
      customValue1:'',
      control:false,
      smsInfoShow: false, // 富信
      smsInfoId: "", // 富信id
      smsInfoTitle: "", // 富信标题
      smsInfoText: "", // 富信内容
      staVisible: false,
      staValue: "7",
      customValue: "",
      startTime: "", // 统计开始时间
      endTime: "", // 统计结束时间
      startTimeOption: {
        disabledDate: (date) => {
          let endTime = this.endTime;
          let time = date.getTime();
          let isDisabled = false;
          if (endTime) {
            isDisabled = time + 24 * 60 * 60 * 1000 >= new Date(endTime).getTime();
          }
          return isDisabled;
        },
      },
      endTimeOption: {
        disabledDate: (date) => {
          let startTime = this.startTime;
          let time = date.getTime();
          let isDisabled = false;
          if (startTime) {
            isDisabled = time <= new Date(startTime).getTime() - 24 * 60 * 60 * 1000;
          }
          return isDisabled;
        },
      },
      statiType: [
        {
          label: "近7天",
          value: "7",
        },
        {
          label: "近15天",
          value: "15",
        },
        {
          label: "近30天",
          value: "30",
        },
        {
          label: "自定义",
          value: "",
        },
      ],
      setDialogVisible: false,
      allShow: false,
      allShowCrowd: false,
      tabIndex: 1, // 1.会员发送 2.短信记录 3.营销效果
      typeEffect: 1, // 1.表示精准营销的效果分析
      precisionMData: null, // 精选营销，二次发送的回显数据
      showEffectAnalysis: false,
      showEffectAnalysisX: false, // 新版效果分析
      officialObj: {}, // 新版效果分析参数
      pageName: "客户营销",
      form: {
        // 官方查询的
        activityTitle: "", // 活动主题
        content: "", // 短信内容
        smsType: "", // 短信类型
        sendStatus: "", // 发送状态
        sendTimeStart: "", // 发送开始时间
        sendTimeEnd: "", // 发送结束时间
        submitTimeStart: "", // 提交时间开始
        submitTimeEnd: "", // 提交时间结束
        version: 2, // 2.官方 1.平台

        phone: "",
        officialFlag: true, // 活动类型
        sendType: "", // 发送类型
        dataFrom: [], // 1.会员发送 2.订单发送 4.5指定号码发送 6.变量短信发送
        // 官方 end
        size: 10,
        current: 1,
      },
      tableData: [],

      crowdTotal: 0,
      versionList: [
        {
          label: "官方分析",
          value: 2,
        },
        {
          label: "平台分析",
          value: 1,
        },
      ],
      smsTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "普通短信",
          value: 0,
        },
        {
          label: "富信",
          value: 1,
        },
        {
          label: "卡片短信",
          value: 2,
        },
      ],
      officialFlagList: [
        {
          label: "官方发送",
          value: true,
        },
        {
          label: "非官方发送",
          value: false,
        },
      ],
      sendTypeList: [
        {
          label: "全部",
          value: "",
        },
        {
          label: "立即发送",
          value: 0,
        },
        {
          label: "定时发送",
          value: 1,
        },
      ],
      sendStatusList: [],
      smsVisible: false,
      tableLoding: false,
      selectEffectObj: {},

      // 短信记录，营销效果相关
      titleShow: true, // 活动主题
      contentShow: true, // 短信内容
      sendTimeShow: true, // 发送时间
      activeTypeShow: false, // 活动类型
      sendTypeShow: false, // 发送类型
      sendStatusShow: false, // 发送状态
      submitTimeShow: false, // 提交时间
      versionShow: false, // 效果分析 (会员发送，订单发送)

      batchId: "", // 批次ID
      officialFlag: true,
      uploadObj: null,
      homeJump: false, // 判断是否首页查看更多跳转过来的
      sendDay: "",
      batchArr: [], //批量下载
      isReMarket: false, // 是否为再次营销
      conditionObj: {}, // 会员发送-再次营销条件数据
      smsDataObj: {}, // 短信内容信息
      typeIndex: 5,
    };
  },
  computed: {
    ...mapState({
      globalBG: "globalBG",
    }),
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    // typeIndex() {
    //   return this.$route.meta.typeIndex; // 1.表示精准营销
    // },
    // pageName(){
    //   console.log(this.tabIndex)
    //   let tab = this.tabIndex
    //   if(tab == 2){
    //       return "短信记录"
    //     }else if(tab == 3){
    //       return "营销效果"
    //     }
    // }
  },
  filters: {
    showSelectedCrowd(selectedCrowd) {
      var res = "";
      if (selectedCrowd) {
        res = "选择人群: ";
        var includeCrowd = selectedCrowd.includeCrowd;
        var includeSearchId = selectedCrowd.includeSearchId;
        if (includeCrowd && includeCrowd.length > 0) {
          selectedCrowd.includeCrowd.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            res += name;
          });
        }
        if (includeSearchId && includeSearchId.length > 0) {
          selectedCrowd.includeSearchId.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            res += name;
          });
        }

        res += " 关系：";
        res += selectedCrowd.includeRule == 1 ? "合并; " : "交集; ";
      }
      if (selectedCrowd.excludeFlag == "1") {
        var excludeP = " 排除人群：";
        var excludeRuleStr = selectedCrowd.excludeRule == 1 ? "合并" : "交集";
        var excludeCrowd = selectedCrowd.excludeCrowd;
        var excludeSearchId = selectedCrowd.excludeSearchId;
        if (excludeCrowd && excludeCrowd.length > 0) {
          excludeCrowd.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            excludeP += name;
          });
        }
        if (excludeSearchId && excludeSearchId.length > 0) {
          excludeSearchId.forEach((item, index) => {
            var name = item.name;
            if (index != "0") {
              name = "," + name;
            }
            excludeP += name;
          });
        }
        excludeP += "  关系：" + excludeRuleStr;
        res += "     " + excludeP;
      }
      return res;
    },
  },
  watch: {
    typeIndex(nVal, oVal) {
      this.tabIndex = 1;
    },
    timeType(nVal) {
      if (nVal == 1) {
        this.clearEffectTime()
      } else {
        this.customValue = ""
      }
    },
    permissions: {
      handler(nVal, oVal) {
        if (nVal&&nVal.length&&nVal.indexOf("hide:second:market") != "-1") {
          // 显示二次营销按钮
          this.isPremissionShow = true;
        }
      },
      immediate: true
    },
  },
  mounted() {
    this.bus.$on("viewRecords", this.handleViewRecords);
    // this.searchSmsRecord();
    // console.log("sendType===", this.sendType);
    // console.log(this.$route);
    // 判断是否是首页跳转过来的
    var homePage = this.$route.params.homePage;
    if (homePage) {
      this.handleSwitch(3);
      // this.showEffectAnalysis = true;
      // this.typeEffect = 1;
      this.homeJump = true;
      // this.sendDay = this.$route.params.day;
      var params = this.$route.params;
      this.officialObj = {
        outerId: params.strategyInstId,
        source: "PRECISION_MARKETING",
        sendTime: params.sendTime,
        sendDay: this.$route.params.day,
      };
      this.showEffectAnalysisX = true;
    }
    //效果分析新tab页
    if (this.$route.query.outerId && this.$route.query.source && this.$route.query.sendTime) {
        this.handleSwitch(3);
        if(this.$route.query.smsType){
          this.officialObj = {
            outerId: this.$route.query.outerId,
            source: this.$route.query.source,
            sendTime: this.$route.query.sendTime,
            smsType: this.$route.query.smsType,
          };
        }else{
          this.officialObj = {
            outerId: this.$route.query.outerId,
            source: this.$route.query.source,
            sendTime: this.$route.query.sendTime,
          };
        }
        console.log(this.officialObj)
        this.showEffectAnalysisX = true;

        // this.handeleEffect(JSON.parse(obj));
      }
    // 会员分析营销
    if (this.$route.query.to == "focusShop") {
      this.handleSwitch(2);
    } else if (this.$route.query.to == "smsRecord") {
      // 订单发送的短信记录页面
      this.handleSwitch(2);
    }

    if (this.typeIndex != "1") {
      if (this.typeIndex == "2" || this.typeIndex == "5") {
        // 会员发送 订单发送
        this.sendStatusList = [
          {
            label: "全部",
            value: "",
          },
          {
            label: "提交中",
            value: 6,
          },
          {
            label: "提交失败",
            value: 7,
          },
          {
            label: "待审核",
            value: 1,
          },
          {
            label: "待发送",
            value: 2,
          },
          {
            label: "审核未通过",
            value: 8,
          },
          {
            label: "已取消",
            value: 4,
          },
          {
            label: "发送中",
            value: 9,
          },
          {
            label: "已发送",
            value: 3,
          },
          {
            label: "发送失败",
            value: 5,
          },
        ];
      } else {
        // 指定跟变量发送
        this.sendStatusList = [
          {
            label: "全部",
            value: "",
          },
          {
            label: "提交中",
            value: 6,
          },
          {
            label: "提交失败",
            value: 7,
          },
          // {
          //   label: "待审核",
          //   value: 1,
          // },
          {
            label: "待发送",
            value: 2,
          },
          {
            label: "已发送",
            value: 3,
          },
          {
            label: "已取消",
            value: 4,
          },
          // {
          //   label: "发送失败",
          //   value: 5,
          // },
        ];
      }
      // this.sendStatusList = this.sendStatusList;
    } else {
      // 精准营销的发送状态
      this.sendStatusList = [
        {
          label: "全部",
          value: "",
        },
        {
          label: "待审核",
          value: 1,
        },
        {
          label: "待发送",
          value: 3,
        },
        {
          label: "审核未通过",
          value: 4,
        },
        {
          label: "已取消",
          value: 5,
        },
        {
          label: "发送中",
          value: 100,
        },
        {
          label: "已发送",
          value: 101,
        },
        {
          label: "发送失败",
          value: 102,
        },
      ];
    }
  },
  beforDestory() {
    this.bus.$off("viewRecords");
  },

  methods: {
    secondMarketingFn(row) {
      this.recordId = row.id
      this.activityTitle = row.activityTitle
      this.smsType = row.smsType
      this.secondVisible = true
    },
    staValueChange(val) {
      if (val) {
        this.customValue = ""
        this.clearEffectTime()
      }
    },

    // 清除效果数据时间
    clearEffectTime() {
      this.startTime = ""
      this.endTime = ""
    },

    showMediaInfo(row) {
      this.smsInfoShow = true
      this.smsInfoId = row.mediaMulitiFileId
      this.smsInfoTitle = row.mediaTitle
      this.smsInfoText = row.content
    },
    showCardInfo(row){
      this.smsInfoCardShow = true
      this.smsInfoCardId = row.mediaTemplateId
    },
    limitInput(event) {
      var value = event.target.value;
      if (value == "0") {
        event.target.value = "";
      } else if (value >= 30) {
        event.target.value = 30;
      } else {
        event.target.value = value.replace(/[^\d]/g, "");
      }
      return event.target.value
    },
    switchAnalysis(val) {
      console.log("switchAnalysis:", val);
      this.submitForm();
    },
    doLayout() {
      var that = this;
      this.$nextTick(() => {
        that.$refs.multipleTable.doLayout();
        var tableBox = that.$refs.multipleTable.$vnode.elm;
        var tbody = tableBox.getElementsByTagName("tbody");
        var tableTbody = tbody[0];
        var fixedTbody = tbody[1];
        var tableTrs = tableTbody.getElementsByTagName("tr");
        var fixedTrs = fixedTbody.getElementsByTagName("tr");

        for (var i = 0; i < tableTrs.length; i++) {
          fixedTrs[i].style.height = tableTrs[i].offsetHeight + "px";
        }
      });
    },
    handleViewRecords() {
      // 效果分析的查看短信记录回跳
      this.showEffectAnalysis = false;
      this.handleSwitch(2);
    },
    handleViewRecord() {
      this.handleSwitch(2);
    },
    // 发送短信弹窗隐藏
    handleCloseSms() {
      this.smsVisible = false;
    },
    // 精准营销的取消发送
    handleCancelPrecision(row, index) {
      this.$confirm("确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        var param = {
          sendTime: row.sendTime,
          // activityRecordId: row.activityRecordId,
          id: row.id
        };
        cancelSendSms(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("取消发送成功");
            this.submitForm();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 取消发送
    handleCancelSend(row, index) {
      this.$confirm("确定要取消吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        iconClass: "iconfont iconicon-jinggao1",
      }).then(() => {
        var param = {
          batchId: row.id,
          officialFlag: row.officialFlag,
        };
        sendCancel(param).then((res) => {
          if (res.code == "1") {
            this.$message.success("取消发送成功");
            this.submitForm();
          } else {
            this.$message.error(res.message);
          }
        });
      });
    },
    // 会员发送-再次营销
    reMarketMember(row) {
      this.isReMarket = true;
      this.conditionObj = JSON.parse(row.sendWhereJson);
      console.log("this.conditionObj:", this.conditionObj);
      // this.conditionObj = {"sendType":1, "crowdPortraitType":["7","6"],"grades":[4,5],"totalPayment":"","startBuyTotalMoney":"20","endBuyTotalMoney":"30","buyTotalCount":"","startBuyTotalCount":"40","endBuyTotalCount":"50","averagePricement":"","startAvgPrice":"70","endAvgPrice":"80","buyerFirstTime":"Customized","startBuyerFirstTime":"2021-04-01 00:00:00","endBuyerFirstTime":"2021-04-02 00:00:00","buyerLastTime":"Customized","startBuyerLastTime":"2021-04-03 00:00:00","endBuyerLastTime":"2021-04-04 00:00:00","skuIds":["53868613051","52123826072"],"labelType":2,"labelIds":[761,772],"province":"","wareIds":["10020893976541","10020316102459"],"size":10,"current":1}
      // this.conditionObj = {"dataFrom": 1,"sendType":3,"shopBuyerGroupId":21353}
      this.smsDataObj = {
        content: row.content,
        filterDay: row.filterDay,
        activityTitle: row.activityTitle,
        jdShortLink: row.jdShortLink,
        url: row.url,
        sendTime: row.sendTime,
        flag: true,
      };
      this.tabIndex = 1;
    },
    // 再次营销
    reMarketing(row, index) {
      // 精选营销的再次营销
      if (this.$route.meta.typeIndex == "1") {
        var strategyInstId = row.strategyInstId;
        var param = {
          strategyInstId,
        };
        getRecordMarketing(param).then((res) => {
          if (res.code == "1") {
            // console.log(res.data, "res.data");
            this.precisionMData = res.data;
            this.precisionMData.title = res.data.activityTitle;
            this.precisionMData.selectedCrowd.includeRule = Number(res.data.selectedCrowd.includeRule);
            this.precisionMData.selectedCrowd.excludeRule = Number(res.data.selectedCrowd.excludeRule);
            this.tabIndex = 1;
          } else {
            this.$message.error(res.message);
          }
        });
      } else {
        // dataForm 5,6 指定号码发送，变量短信发送
        againSend(row.id).then((res) => {
          if (res.code == "1" || res.data.code == "1") {
            var data = res.data;

            var content = data.content;
            if (content.indexOf("拒收请回复R") != "-1") {
              content = content.substr(0, content.indexOf("拒收请回复R"));
            }
            this.uploadObj = {
              totalMobile: data.count,
              fid: data.fileId,
              content: content,
            };
            this.tabIndex = 1;
          } else {
            this.$message.error(res.data.message);
          }
        });
      }
    },
    /** 短信记mou录列表查询  */
    searchSmsRecord() {
      var param = {};
      getSmsRecord().then((res) => {});
    },

    /** 短信记录，营销效果显示相关搜索条件  */
    showCondition() {
      var tabIndex = this.tabIndex;
      var typeIndex = this.typeIndex;
      this.titleShow = true;
      this.contentShow = true;
      this.sendTimeShow = true;
      this.versionShow = false;

      if (tabIndex == "3") {
        this.sendStatusShow = false;
        this.submitTimeShow = false;

        if (typeIndex == "2" || typeIndex == "5") {
          // 会员发送，订单发送
          this.versionShow = true;
        }

        // 效果分析
        if (typeIndex == "1") {
          // 精准营销
          this.activeTypeShow = false;
          this.sendTypeShow = false;
        } else {
          if (typeIndex != "3" && typeIndex != "4") {
            this.activeTypeShow = true;
          } else {
            this.activeTypeShow = false;
          }
          this.sendTypeShow = true;
        }
      } else if (tabIndex == "2") {
        // 短信记录
        if (typeIndex != "1") {
          //  非精准营销
          this.sendTypeShow = true;
          if (typeIndex != "3" && typeIndex != "4") {
            this.activeTypeShow = true;
          } else {
            this.activeTypeShow = false;
          }
        }

        this.sendStatusShow = true;
        this.submitTimeShow = true;
      }
    },

    goBackHomeX(val) {
      this.showEffectAnalysisX = false;
      this.homeJump = false;
    },

    /** 后退 */
    goBackHome(val) {
      this.showEffectAnalysis = false;
      this.homeJump = false;
    },
    /** 效果分析 */
    handeleEffect(row) {
      this.selectEffectObj = row;
      if (this.typeIndex == "1") {
        // this.typeEffect = 1;
        row.source = "PRECISION_MARKETING";
        this.officialObj = {
          outerId: row.strategyInstId,
          source: "PRECISION_MARKETING",
          sendTime: row.sendTime,
          smsType: row.smsType,
        };
        this.showEffectAnalysisX = true;
      } else {
        // 非精准营销的效果分析
        var type = 1;
        if (this.typeIndex == "3" || this.typeIndex == "4") {
          // 非官方
          type = 2;
        }
        this.selectEffectObj.smsType = type;

        if (row.version == "2") {
          // 订单发送，会员发送的新版效果分析
          // this.typeEffect = 5;

          // this.officialObj = {
          //   outerId: row.bid,
          //   source: "PACKAGE_SEND",
          //   sendTime: row.sendDate,
          //   smsType: row.smsType,
          // };
          // this.showEffectAnalysisX = true;

          let routeUrl =this.$router.resolve({
          path: "/marketing/marketing/self_order_send",
          query: {
            outerId: row.bid,
            source: "PACKAGE_SEND",
            sendTime: row.sendDate,
            smsType: row.smsType,
          },
          });
          window.open(routeUrl.href, "_blank");
          return;
        } else {
          this.typeEffect = 2;
        }
      }
      this.selectEffectObj.typeIndex = this.typeIndex;
      this.showEffectAnalysis = true;
    },
    //批量下载
    batchUpload() {
      var dayNum = this.staValue;
      if (this.staValue === "") {
        dayNum = this.customValue;
        if(this.customValue>=30){
          dayNum = 30
        }
        if (!dayNum && this.timeType == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType == 2 && !this.startTime) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType == 2 && !this.endTime) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      let param = {
        activityTitle: this.form.activityTitle,
        content: this.form.content,
        dayNum: dayNum,
        source: "",
        exportRemark:this.customValue1,
        startTime: this.startTime,
        endTime: this.endTime,
      };
      var source = "";
      switch (this.typeIndex) {
        case 1:
          source = 4; // 精准营销
          break;
        case 2:
          source = 1; // 会员发送
          break;
        case 5:
          source = 2; // 订单发送
          break;
        default:
          break;
      }
      param.source = source;

      if (this.form.sendTimeStart) {
        param.sendTimeStart = this.form.sendTimeStart;
      }
      if (this.form.sendTimeEnd) {
        param.sendTimeEnd = this.form.sendTimeEnd;
      }
      let paramStr = "";
      for (var key in param) {
        let temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportMarketing(paramStr).then((res)=>{
        if(res.code==1){
          this.staVisible = false;
          this.control = true
          this.flags = 1
        }else{
          this.$message.error(res.message);
        }
      })
    },
    getphone1(val){
      var dayNum = this.staValue;
      if (this.staValue === "") {
        dayNum = this.customValue;
        if(this.customValue>=30){
          dayNum = 30
        }
        if (!dayNum && this.timeType == 1) {
          this.$message.warning("请输入天数！");
          return;
        }
        if (this.timeType == 2 && !this.startTime) {
          this.$message.warning("请选择开始时间！");
          return;
        }
        if (this.timeType == 2 && !this.endTime) {
          this.$message.warning("请选择结束时间！");
          return;
        }
      }
      let param = {
        activityTitle: this.form.activityTitle,
        content: this.form.content,
        dayNum: dayNum,
        source: "",
        exportRemark:val
      };
      var source = "";
      switch (this.typeIndex) {
        case 1:
          source = 4; // 精准营销
          break;
        case 2:
          source = 1; // 会员发送
          break;
        case 5:
          source = 2; // 订单发送
          break;
        default:
          break;
      }
      param.source = source;

      if (this.form.sendTimeStart) {
        param.sendTimeStart = this.form.sendTimeStart;
      }
      if (this.form.sendTimeEnd) {
        param.sendTimeEnd = this.form.sendTimeEnd;
      }
      let paramStr = "";
      for (var key in param) {
        let temp = "&" + key + "=" + param[key];
        paramStr += temp;
      }
      paramStr = paramStr.substr(1);
      exportMarketing(paramStr).then((res)=>{
        if(res.code==1){
          this.staVisible = false;
          this.control = true
        }else{
          this.$message.error(res.message);
        }
      })

    },
    /** 短信记录 */
    handleSmsRecord(row) {
      this.batchId = row.id;
      this.officialFlag = row.officialFlag;
      // console.log(this.batchId);
      this.smsVisible = true;
    },
    handleSwitch(index) {
      console.log(this.typeIndex, 666);
      this.tabIndex = index;
      let yy = new Date().getFullYear(); //当前年份
      let mm = new Date().getMonth() + 1 < 10 ? "0" + (new Date().getMonth() + 1) : new Date().getMonth() + 1;
      let dd = new Date().getDate() < 10 ? "0" + new Date().getDate() : new Date().getDate(); //当前天数
      if (index == "3") {
        // 营销效果
        this.clearCondition();
        this.form.sendTimeStart = this.getDateStr(-30) + " 00:00:00";
        this.form.sendTimeEnd = `${yy}-${mm}-${dd} 23:59:59`;
        this.showCondition();
        this.submitForm();
      } else if (index == "2") {
        // 短信记录
        this.clearCondition();

        this.form.submitTimeStart = this.getDateStr(-30) + " 00:00:00";
        this.form.submitTimeEnd = `${yy}-${mm}-${dd} 23:59:59`;
        this.showCondition();
        this.submitForm();
      }
    },
    // 清空条件
    clearCondition() {
      this.tableLoding = false;
      this.form = {
        activityTitle: "", // 活动主题
        content: "", // 短信内容
        sendStatus: "", // 发送状态
        sendTimeStart: "", // 发送开始时间
        sendTimeEnd: "", // 发送结束时间
        submitTimeStart: "", // 提交时间开始
        submitTimeEnd: "", // 提交时间结束
        officialFlag: true, // 活动类型
        sendType: "", // 发送类型
        smsType: "", // 短信类型
        dataFrom: [], // 1.会员发送 2.订单发送 4.5指定号码发送 6.变量短信发送
        version: 2,
        // 官方 end
        size: 10,
        current: 1,
      };
      this.tableData = [];
      this.crowdTotal = 0;
    },
    // 跳转到短信签名
    toSet() {
      let routeUrl = this.$router.resolve({
        path: "/backstage/signature_management/signature_report_official",
        // query: { to: "/signature_management/signature_report_official" },
      });
      window.open(routeUrl.href, "_blank");
    },
    handleSizeChange(val) {
      this.form.size = val;
      this.submitForm();
    },
    handleCurrentChange(val) {
      this.form.current = val;
      this.submitForm();
    },
    submitForm() {
      var param = {
        activityTitle: this.form.activityTitle,
        content: this.form.content,
        size: this.form.size,
        current: this.form.current,
        phone: this.form.phone,
      };

      if (this.typeIndex == "1") {
        // 精选营销的营销效果，走官方发送的接口
        if (this.form.sendTimeStart) {
          param.sendTimeStart = this.form.sendTimeStart;
        }
        if (this.form.sendTimeEnd) {
          param.sendTimeEnd = this.form.sendTimeEnd;
        }
        if (this.tabIndex == "2") {
          // 短信记录
          if (this.form.submitTimeStart) {
            param.submitTimeStart = this.form.submitTimeStart;
          }
          if (this.form.submitTimeEnd) {
            param.submitTimeEnd = this.form.submitTimeEnd;
          }
          param.sendStatus = this.form.sendStatus;
        } else if (this.tabIndex == "3") {
          // 营销效果
          param.sendStatus = 101;
        }
        this.tableLoding = true;
        getRecordListOfficial(param).then((res) => {
          this.tableLoding = false;
          if (res.code == "1") {
            this.tableData = res.data.records;
            this.crowdTotal = +res.data.total;
          }
          this.doLayout();
        });
      } else {
        // 非精准营销页面
        var dataFrom = [];
        if (this.typeIndex == "2") {
          dataFrom = [1];
        } else if (this.typeIndex == "5") {
          // 订单发送
          dataFrom = [2];
        } else if (this.typeIndex == "3") {
          // 指定号码发送
          dataFrom = [4, 5, 13];
        } else if (this.typeIndex == "4") {
          // 变量短信发送
          dataFrom = [6];
        }
        param.dataFrom = dataFrom.join(",");

        if (this.tabIndex == "2") {
          if (this.form.sendTimeStart) {
            param.sendTimeStart = this.form.sendTimeStart;
          }
          if (this.form.sendTimeEnd) {
            param.sendTimeEnd = this.form.sendTimeEnd;
          }
          // 短信记录查询
          if (this.typeIndex != "3" && this.typeIndex != "4") {
            // 非指定号码，非变量短信发送
            param.officialFlag = this.form.officialFlag;
          } else {
            param.officialFlag = false;
          }

          if (this.form.submitTimeStart) {
            param.submitTimeStart = this.form.submitTimeStart;
          }
          if (this.form.submitTimeEnd) {
            param.submitTimeEnd = this.form.submitTimeEnd;
          }

          param.sendType = this.form.sendType;
          param.smsType = this.form.smsType;
          param.sendStatus = this.form.sendStatus;

          this.tableLoding = true;
          sendBatchPage(param)
            .then((res) => {
              this.tableLoding = false;
              if (res.code == "1") {
                this.tableData = res.data.records;
                this.crowdTotal = +res.data.total;
              }
              this.doLayout();
            })
            .catch((err) => {
              if (err) {
                this.tableLoding = false;
              }
            });
        } else if (this.tabIndex == "3") {
          // 非精准营销，营销效果页面
          if (this.typeIndex != "3" && this.typeIndex != "4") {
            // 非指定号码，非变量短信发送
            param.isOfficial = this.form.officialFlag;
          } else {
            param.isOfficial = false;
          }

          if (this.typeIndex == "2" || this.typeIndex == "5") {
            param.version = this.form.version;
          }

          param.type = this.form.sendType;
          param.sendDateStart = this.form.sendTimeStart;
          param.sendDateEnd = this.form.sendTimeEnd;
          param.smsType = this.form.smsType;
          this.tableLoding = true;

          getEffectPage(param).then((res) => {
            this.tableLoding = false;
            if (res.code == "1") {
              this.tableData = res.data.records;
              this.tableData = this.tableData.map((item) => {
                item.sendTime = item.sendDate;
                item.sendSubmitNum = item.shopBuyerNum;
                return item;
              });
              this.crowdTotal = +res.data.total;
            }
            this.doLayout();
          });
        }
      }
    },
    resetForm() {
      if (this.typeIndex == "1") {
        // 精准营销
        this.form.activityTitle = "";
        this.form.content = "";
        this.form.sendTimeStart = "";
        this.form.sendTimeEnd = "";
        this.form.submitTimeStart = "";
        this.form.submitTimeEnd = "";
        this.form.sendStatus = "";
        this.form.size = 10;
        this.form.current = 1;
        this.submitForm();
      } else {
        this.form = {
          activityTitle: "", // 活动主题
          content: "", // 短信内容
          sendStatus: "", // 发送状态
          sendTimeStart: "", // 发送开始时间
          sendTimeEnd: "", // 发送结束时间
          submitTimeStart: "", // 提交时间开始
          submitTimeEnd: "", // 提交时间结束

          officialFlag: true, // 活动类型
          sendType: "", // 发送类型
          smsType: "", // 短信类型
          dataFrom: [], // 1.会员发送 2.订单发送 4.5指定号码发送 6.变量短信发送
          // 官方 end
          size: 10,
          current: 1,
        };
        if (this.versionShow) {
          this.form.version = 2;
        }
        this.submitForm();
      }
    },
    clearTime1() {
      this.form.submitTimeStart = "";
      this.form.submitTimeEnd = "";
    },
    clearTimeSendTime() {
      this.form.sendTimeStart = "";
      this.form.sendTimeEnd = "";
    },
    searchForm() {},
  },
};
</script>

<style lang="scss" scoped>
/deep/ .el-table th.is-leaf {
  height: 50px;
}
/deep/ .el-table th > .cell {
  height: 40px !important;
  line-height: 39px !important;
  font-size: 14px;
  font-family: Microsoft YaHei;
  -webkit-font-smoothing: antialiased;
  color: #333;
}
.table-message {
  color: #7f85e9 !important;
  cursor: pointer;
}
.footer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 20px;
  .cancel,
  .confirm {
    width: 98px;
    font-size: 14px;
    height: 32px;
  }
  .cancel {
    margin-right: 8px;
    color: #999999;
    border: 1px solid #cccccc;
    background-color: #fff;
    &:hover {
      color: #fe4d45;
      border: 1px solid #fe4d45;
      background-color: #fff4f4;
    }
  }
  .confirm {
    color: #ffffff;
    background-color: #fe4d45;
    &:hover {
      color: #fff;
      opacity: 0.9;
      background-color: #fe4d45;
    }
  }
}

.rich_title {
  color: #7f85e9;
  font-size: 14px;
  cursor: pointer;
}

.hoveTitle {
  text-align: left;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.hoveTitleShowMore {
  white-space: normal;
}

.update {
  cursor: pointer;
}
.question_icon {
  width: 14px;
  height: 14px;
  color: #7f85e9 !important;
  display: inline-block;
  line-height: 12px !important;
  text-align: center;
  border-radius: 14px;
  border: 1px solid #7f85e9;
  font-size: 12px !important;
  font-weight: normal !important;
  margin-left: 8px;
  &:hover {
    color: #fe4d45 !important;
    border: 1px solid #fe4d45;
  }
}
.record-btn {
  cursor: pointer;
  color: #7f85e9;
  &:hover {
    color: #fe4d45;
  }
}
.record-btn.is-disabled {
  color: #ddd;
}
.select-box {
  span {
    margin-right: 10px;
  }
}
.tip-box {
  padding-left: 24px;
  text-align: left;
  line-height: 21px;
  font-size: 14px;
  margin-top: 12px;
  color: #999999;
  background: #fffaee;
  position: relative;
  margin: 20px 28px 20px 28px;
  line-height: 42px;
  .warning-icon {
    color: #fe8f8a;
    font-size: 14px;
    position: absolute;
    left: 5px;
    top: 13px;
  }
}
.box-shadow {
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  background: #fff;
}
.record-box {
  .top-box {
    margin: 11px 20px;
    min-width: 1066px;
    // padding-top: 20px;
  }
  .tab-line {
    font-size: 14px;
    color: #666666;
    border-bottom: 1px solid #dddddd;
    margin: 20px 28px 0 28px;
    .tab-item {
      // padding: 15px 0;
      text-align: center;
      width: 106px;
      height: 36px;
      line-height: 36px;
      display: inline-block;
      position: relative;
      cursor: pointer;
      margin-right: 2px;
      border: 1px solid #dddddd;
      border-bottom: none;
      // &:first-child{
      //   margin-right: 22px;
      // }
      span {
        position: absolute;
        width: 100%;
        left: 50%;
        height: 2px;
        transform: translateX(-50%);
        bottom: -2px;
        display: none;
      }
      &.active {
        border-top: 2px;
        span {
          display: block;
          background: #fff;
        }
      }
    }
  }
  /** 表单搜索  */
  .search-box {
    margin-top: 20px;
    padding-bottom: 20px;
    .el_btn {
      text-align: center;
      .search {
        width: 98px;
        height: 32px;
        font-size: 14px;
        border-radius: 3px;
        color: #fe4d45;
        border: 1px solid #fe4d45;
        background-color: #fff;
        // margin-left: 50px;
        &:hover {
          color: #fff;
          border: 1px solid #fff;
          background-color: #fe4d45;
        }
      }
      .reset {
        width: 98px;
        height: 32px;
        font-size: 14px;
        border-radius: 3px;
        color: #666666;
        border: 1px solid #dddddd;
        background-color: #fff;
        &:hover {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
      }
    }
    .el-input,
    .el-select {
      width: 280px;
    }
    .my_select_time {
      display: flex;
      align-items: center;
    }
  }
  .operation {
    cursor: pointer;
    color: #7f85e9;
    &:hover {
      color: #fe4d45;
    }
  }
  /** 表格内容 */
  .table-box {
    // margin: 20px;
    margin-top: 20px;
    padding: 0 28px 24px 28px;
    .batchUpload {
      padding-bottom: 10px;
      .status_btn3 {
        width: 98px;
        padding: 5px 12px;
        height: 32px;
        color: #ffffff;
        border-radius: 3px;
        border: 1px solid #fe4d45;
        background-color: #fe4d45;
        &:hover {
          color: #fff;
          opacity: 0.9;
          background-color: #fe4d45;
        }
        &:active {
          color: #fe4d45;
          border: 1px solid #fe4d45;
          background-color: #fff4f4;
        }
        &.is-disabled {
          color: #fff;
          background-color: #fab6b6;
          border-color: #fab6b6;
        }
      }
    }
    .control-button {
      .el-button {
        width: 65px;
        margin-left: 0 !important;
      }
      .operation {
        cursor: pointer;
        color: #7f85e9;
        &:hover {
          color: #fe4d45;
        }
      }
    }
  }
}

/* 温馨提示表格 */
.topTis {
  margin: 20px 28px 0 28px;
  // display: flex;
  // align-items: baseline;
  position: relative;

  color: #333333;
  font-size: 14px;
  background: #fafafa;
  opacity: 1;
  padding: 12px;
  color: #333333;
  .desc {
    line-height: 20px;
    .setting-text {
      margin-bottom: 8px;
      span {
        font-size: 14px;
        color: #7f85e9;
        margin-left: 30px;
        cursor: pointer;
        &:hover {
          color: #fe4d45 !important;
        }
      }
    }
  }
  p {
    margin: 0px;
    line-height: 20px;
    // width: 700px;
  }
}
</style>
